import { useMemo } from "react";
import { PAYEE_CATALOG_TYPE_ORDERING, PAYEE_CATALOG_TYPE_DELIVERY } from "../../constants/payeeCatalog";
import { FULFILLMENT_METHOD_PICKUP, FULFILLMENT_METHOD_DELIVERY } from "../../constants/payeeOrder"

import {countCartItems} from "../../utils/cartUtils"
import {capitalizeAllWords} from "../../utils/stringUtils"
import { addDuration, timestampToDateString } from "../../utils/datetimeUtils";

import {StoreIcon, DeliveryIcon, PinIcon} from "../../constants/serverImages"
import Icon from "../../components/Icon";
const PayeeOrderDetails = ({payeeOrder, onClick=()=>{}}) => {
    const {payeeCatalogType="", catalogMetadata={}, paidAt=0} = payeeOrder || {}
    const {
        fulfillmentMethod="", // handle ORDERING orders
        deliveryAddress={},
        waitTimes,
        prepTimes
    } = catalogMetadata
    let readyByAvg = 0
    //ORDERING
    const fulfillmentIcon = fulfillmentMethod === FULFILLMENT_METHOD_PICKUP ? StoreIcon : fulfillmentMethod === FULFILLMENT_METHOD_DELIVERY ? DeliveryIcon : ""
    if (prepTimes && payeeCatalogType === PAYEE_CATALOG_TYPE_ORDERING) {
        readyByAvg = addDuration(paidAt, prepTimes.avg)
    }
    //DELIVERY
    const deliveryCity = deliveryAddress && deliveryAddress.city ? capitalizeAllWords(deliveryAddress.city) : ""
    const itemCount = useMemo(() => countCartItems(payeeOrder), [payeeOrder])
    if (waitTimes && payeeCatalogType === PAYEE_CATALOG_TYPE_DELIVERY){
        readyByAvg = addDuration(paidAt, waitTimes.avg)
    }

    let buttonLabel = `View ${itemCount} items`
    if (payeeCatalogType === PAYEE_CATALOG_TYPE_DELIVERY) {
        buttonLabel = "View delivery details"
    }
    return (
        <div>
            <div>
                <button className="button small secondary" onClick={onClick}>{buttonLabel}</button>
            </div>
            {
                payeeCatalogType === PAYEE_CATALOG_TYPE_ORDERING && fulfillmentMethod?
                <div className="display-flex align-items-center padding-5px font-size-14px font-weight-600 color-dark-grey"><img src={fulfillmentIcon} height={25} width="auto" /> <div className="margin-left-5px">{String(fulfillmentMethod).toUpperCase()}</div></div>
                :
                null
            }
            {
                [PAYEE_CATALOG_TYPE_DELIVERY, PAYEE_CATALOG_TYPE_ORDERING].includes(payeeCatalogType) && deliveryCity?
                <div className="display-flex align-items-center margin-top-5px font-size-14px font-weight-600 color-dark-grey text-align-left"><img src={PinIcon} height={25} width="auto" /> <div className="margin-left-5px">{deliveryCity}</div></div>
                :
                null
            }
            {
                readyByAvg > 0 ?
                <div className="margin-left-5px font-size-14px display-flex align-items-center"><Icon icon="schedule"/> <span className="font-weight-600 margin-left-5px">{timestampToDateString(readyByAvg, "t")}</span></div>
                :
                null
            }
        </div>
    )
}

export default PayeeOrderDetails